import { ComponentIdSpan } from "@inter-ikea-core/core";
var CoreToolboxComponentIds = /** @class */ (function () {
    function CoreToolboxComponentIds() {
    }
    var _a;
    _a = CoreToolboxComponentIds;
    CoreToolboxComponentIds.BaseId = ComponentIdSpan.CORE_TOOLBOX_BASE_ID;
    CoreToolboxComponentIds.IpexViewerComponentId = _a.BaseId + 1; // placed this component in ipex-viewer-core-adapter, left the component id here since that package does not have its own range of ids
    CoreToolboxComponentIds.ViewerSurfaceReferenceComponent = _a.BaseId + 2;
    CoreToolboxComponentIds.CanvasComponentId = _a.BaseId + 3; // placed this component in ipex-viewer-core-adapter, left the component id here since that package does not have its own range of ids
    CoreToolboxComponentIds.KvadratVPCComponentId = _a.BaseId + 4;
    return CoreToolboxComponentIds;
}());
export { CoreToolboxComponentIds };
//# sourceMappingURL=CoreToolboxComponentIds.js.map